$('.xcarousel').each(function(i,el){
	$(el).hasClass('xcarousel-product')?
	$(el).slick({
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	}):
	$(el).slick({
			autoplay: true, 
			dots: true, 
			pauseOnFocus: true,
			arrows:false
	});
});

(()=>{

	var fader = $('.card.fade');
	$(document).ready(()=>{
		fader.each((i,el)=>{
			if($(el).offset().top < window.pageYOffset + $(window).height()){
				fadeIn(el);
			}
		});
	});
	$(document).on('scroll',function(e){
		fader.each(function(){
			var bottom_of_object = $(this).offset().top;
			var bottom_of_window = $(window).scrollTop() + $(window).height();
	
			/* If the object is completely visible in the window, fade it it */
			if (bottom_of_window > bottom_of_object) {
				fadeIn(this);
			}
		});
	});
})();

function fadeIn(el){
	// $(el).animate({
	// 	'opacity': '1'
	// }, 500);
	$(el).addClass('reveal');
};

const searchTpl = $(`
	<div class="search flex-column">
		<div class="mw-100 px-3">
			<i class="fas fa-times text-white" onclick="searchTpl.remove()"></i>
			<form method="GET" action='/paieska'>
				<input id="searchInput" type="text" name="name" placeholder="Paieška" autofocus>
				<div class="d-flex justify-content-end mt-3">
					<button type="submit" class="btn btn-sm btn-primary">
						<i class="fas fa-search text-white mr-3"></i>
						Ieškoti
					</button>
				</div>
			</form>
		</div>
	</div>
`);
$('a[href="/paieska"]:not(".direct")').click((e)=>{
	e.preventDefault();
	$('body').append(searchTpl);
	// function submitSearch(e){
	// 	let val = e.currentTarget.value;
	// 	if (e.which == 13 && val)
	// 		window.location = '/paieska?name=' + xhelper.string.aliasify(val); 
	// };
});


$('.product-timeout').each(function (i, el) {
	var timer = $(el).find('.product-timeout-time'),
	dateStr = timer[0].getAttribute('data-date-end');
	// timerVal = new Date(endDate).getTime();
	// var dateStr = "2011-08-03 09:15:11"; //returned from mysql timestamp/datetime field
	var a = dateStr.split(" ");
	var d = a[0].split("-");
	var t = a[1].split(":");
	var timerVal = new Date(d[0], (d[1] - 1), d[2], t[0], t[1], t[2]);
	new countdown(timerVal, timer);

});

function countdown(timerVal, timer) {
	var setCountdown = new Promise(function (resolve, rej) {
		let countdown = setInterval(function () {
			var now = new Date().getTime(),
				distance = timerVal - now,
				days = Math.floor(distance / (1000 * 60 * 60 * 24)),
				hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
				minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
				seconds = Math.floor((distance % (1000 * 60)) / 1000),
				timerHtml = `
					${days !==0 ? days + 'd ':''} 
					${hours !==0 ? hours + 'val ':''} 
					${minutes !==0 ? minutes + 'min ':''} 
					${seconds !==0 ? seconds + 's ':'0 s'}
				`;

			timer.html(timerHtml);
			resolve(timerHtml);
			if (distance < 0) {
				timer.html('Aukcionas baigtas');
			}
		}, 1000);

	});

	setCountdown.then(function () {
		timer.parent().addClass('active');
	});
}


$.extend($.validator.messages, {
	// required: "Šis laukas yra privalomas.",
	// remote: "Prašau pataisyti šį lauką.",
	// email: "Prašau įvesti teisingą elektroninio pašto adresą.",
	// url: "Prašau įvesti teisingą URL.",
	// date: "Prašau įvesti teisingą datą.",
	// dateISO: "Prašau įvesti teisingą datą (ISO).",
	// number: "Prašau įvesti teisingą skaičių.",
	// digits: "Prašau naudoti tik skaitmenis.",
	// creditcard: "Prašau įvesti teisingą kreditinės kortelės numerį.",
	// equalTo: "Prašau įvestį tą pačią reikšmę dar kartą.",
	// extension: "Prašau įvesti reikšmę su teisingu plėtiniu.",
	// maxlength: $.validator.format("Prašau įvesti ne daugiau kaip {0} simbolių."),
	// minlength: $.validator.format("Prašau įvesti bent {0} simbolius."),
	// rangelength: $.validator.format("Prašau įvesti reikšmes, kurių ilgis nuo {0} iki {1} simbolių."),
	// range: $.validator.format("Prašau įvesti reikšmę intervale nuo {0} iki {1}."),
	// max: $.validator.format("Prašau įvesti reikšmę mažesnę arba lygią {0}."),
	min: $.validator.format("Mažiausiai leidžiamas kiekis yra nemažesnis kaip {0}.")
});